import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./Promozioni.css";

export default function PromozioniLayout() {
  return (
    <div className="promo-page">
      <div className="promo-shell">
        <div className="promo-shell-inner">
          <header className="promo-header promo-header--enhanced">
            <div className="promo-header-copy">
              <span className="promo-kicker">Admin · Stirup</span>
              <h1 className="promo-title">Promozioni</h1>
              <p className="promo-subtitle">
                Gestisci promozioni, welcome e referral. Definisci articoli, regole e destinatari.
              </p>
            </div>

            <nav className="promo-nav promo-nav--below-title">
              <NavLink
                to="welcome"
                className={({ isActive }) => `promo-nav-tab ${isActive ? "is-active" : ""}`}
              >
                Welcome
              </NavLink>
              <NavLink
                to="referral"
                className={({ isActive }) => `promo-nav-tab ${isActive ? "is-active" : ""}`}
              >
                Referral
              </NavLink>
              <NavLink
                to="list"
                className={({ isActive }) => `promo-nav-tab ${isActive ? "is-active" : ""}`}
              >
                Promozioni
              </NavLink>
            </nav>
          </header>

          <div className="promo-page-section">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
